(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("$rdf"));
	else if(typeof define === 'function' && define.amd)
		define(["$rdf"], factory);
	else if(typeof exports === 'object')
		exports["UI"] = factory(require("$rdf"));
	else
		root["UI"] = factory(root["$rdf"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__264__) => {
return 